<template>
    <div id="bg-front" :style="backgroundImg"
         class="w-full bg-black flex flex-col items-center justify-center">
        <h1 class="text-center text-3xl md:text-4xl text-white mb-4 bg-black rounded p-2">
            {{routeData.title}}
        </h1>
        <h1 v-responsive.lg.md.xl class="text-center text-2xl text-white bg-grey-darker rounded p-1">
            {{routeData.sub_title}}
        </h1>
        <div v-if="shouldShow" v-responsive.xs.sm>
            <ul class="text-center w-full">
                <li v-for="page in pages"
                    class="bg-blue-dark hover:bg-blue-dark text-white font-bold py-2 px-4 rounded-full my-2">
                    <router-link class="text-grey-lightest" :to="page.route.to">
                        {{ page.route.name }}
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Header",
        props: ['routeData', 'pages'],
        data() {
            return {
                shouldShow: false
            }
        },
        computed: {
            backgroundImg() {
                if (this.$route.name === 'home') {
                    this.shouldShow = true;
                    return 'background: url("' + this.$props.routeData.image + '");  height: 30rem;';
                }
                this.shouldShow = false;
                return 'background: url("' + this.$props.routeData.image + '");  height: 12rem;';
            }
        }
    }
</script>

<style scoped>
    #bg-front {
        filter: contrast(80%);
        height: 30rem;
        background-size: 100%;
    }
</style>
